import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import LoginButton from '../../components/misc/LoginButton';
import NavigationBar from '../../components/misc/NavigationBar';
import Footer from '../../components/misc/Footer';
import { detectMobileOS } from '../../utils/userAgentUtils';
import { MobileOS } from '../../types/misc';

export default function MagicLoginPage() {
  const { t } = useTranslation();

  const [params] = useSearchParams();
  const redirectTo = params.get('redirectTo') ?? '/';
  const mobileOS = detectMobileOS();

  return (
    <div className="flex min-h-screen flex-col">
      <NavigationBar />
      <div className="flex flex-1 items-center justify-center px-4 md:px-0">
        <div className="my-4 w-full rounded-lg bg-secondary p-4 md:w-2/5 md:p-8">
          <div className="flex flex-col items-center justify-center space-y-4 text-center">
            <img
              src={`${process.env.PUBLIC_URL}/images/misc/hero.png`}
              alt="Login Illustration"
              className="aspect-square w-1/2 rounded bg-opacity-50"
            />
            <h1 className="text-2xl font-medium text-primary-900">{t('page.magicLogin.title')}</h1>
            <p className="text-sm text-primary-900">
              {mobileOS === MobileOS.UNKNOWN
                ? t('page.magicLogin.unknownDescription')
                : t('page.magicLogin.mobileDescription')}
            </p>
            <div className="flex justify-center">
              <LoginButton redirectTo={redirectTo} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
